var componentRequireContext = require.context("components", true, /front\/top|front\/common\/FloatingPromotionBanner|youtube\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
